import {
    AddToPhotos,
    Delete,
    DeleteSweep,
    Info,
    MenuOpen,
  } from "@mui/icons-material";
  import { IconButton, Menu, MenuItem } from "@mui/material";
  import React, { useState } from "react";
  import EditIcon from "@mui/icons-material/Edit";
  import PropTypes from "prop-types";
  import { useSelector } from "react-redux";
  
  export default function TableDropwdownActions({
    handleApprovalSubmission,
    handleEditData,
    handleDetailData,
    deleteClassItem,
    deleteItem,
    activeClassItem,
    styles,
    row,
    status,
  }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
  
    const role = useSelector((state) => state.auth.dataToken.roleId.roleName);
  
    return (
      <>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={() => {
            setAnchorEl(event.target);
            setOpen(true);
          }}
        >
          <MenuOpen />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={() => {
            setOpen(false);
          }}
        >
          {(parseInt(status) === 1 || parseInt(status) === 2) && 
          (role === "super-admin") | (role === "admin") ? (
            <MenuItem onClick={() => handleApprovalSubmission()}>
              <Info className={styles.actionButtonEdit} fontSize="small" />
              Approval Pengajuan
            </MenuItem>
          ) : (
            ""
          )}
  
          <MenuItem onClick={() => handleDetailData()}>
            <Info className={styles.actionButtonEdit} fontSize="small" />
            Detail
          </MenuItem>
  
          {role === "super-admin" ? (
            <MenuItem onClick={() => handleEditData()}>
              <EditIcon className={styles.actionButtonEdit} fontSize="small" />
              Edit
            </MenuItem>
          ) : (
            ""
          )}
  
          {role === "super-admin" ? (
            <MenuItem onClick={() => deleteItem()}>
              <DeleteSweep
                className={styles.actionButtonDelete}
                fontSize="small"
              />
              Delete
            </MenuItem>
          ) : (
            ""
          )}
  
          {role === "super-admin" ? (
            <MenuItem onClick={() => deleteClassItem()}>
              <Delete className={styles.actionButtonDelete} fontSize="small" />
              Delete Permanent
            </MenuItem>
          ) : (
            ""
          )}
  
          {role === "super-admin" && !row.isActive && (
            <MenuItem onClick={() => activeClassItem()}>
              <AddToPhotos className={styles.actionButtonEdit} fontSize="small" />
              Aktifkan
            </MenuItem>
          )}
        </Menu>
      </>
    );
  }
  
  TableDropwdownActions.propTypes = {
    handleApprovalSubmission: PropTypes.func.isRequired,
    handleEditData: PropTypes.func.isRequired,
    handleDetailData: PropTypes.func.isRequired,
    deleteClassItem: PropTypes.func.isRequired,
    deleteItem: PropTypes.func.isRequired,
    activeClassItem: PropTypes.func.isRequired,
    styles: PropTypes.object.isRequired,
    row: PropTypes.object.isRequired,
    status: PropTypes.number,
  };
  